export default __webpack_public_path__ + "static/media/byAJV.9b6cd469.png";